<template>
  <div>
    <div class="modal" v-if="modalState === 'explain'">
      <TitleArea
        text="景品応募"
        @click-close="onClickClose"
        :showReturn="true"
      />
      <div class="modal-content-area">
        <p class="explain">100ポイントにつき1回、<br />抽選に参加できます。</p>
        <div class="card" v-for="item in keihinList" :key="item.name">
          <div class="card-flex-area">
            <div>
              <img :src="item.img" />
            </div>
            <div class="text-area">
              <p>{{ item.name }}</p>
              <p class="right">{{ item.sub }}</p>
            </div>
          </div>
          <div
            class="buttonArea red"
            @click="onClickGoSubmitPage(item)"
            :class="{ disabled: canUsePoint < 100 }"
          >
            <div class="buttonMainArea">応募する</div>
          </div>
        </div>
        <PresentMyData />
        <PointShortage v-if="canUsePoint < 100" />
      </div>
    </div>
    <div class="modal" v-else-if="modalState === 'send'">
      <TitleArea
        text="景品応募"
        @click-close="onClickCloseSubmitPage"
        :showReturn="true"
      />
      <div class="modal-content-area">
        <div class="oubo-img-wrapper">
          <img class="oubo-img" :src="selectedCourse.img" />
        </div>
        <p class="oubo-explain">{{ selectedCourse.name }} <br />に応募</p>
        <InputMailAddress
          @input="changeMailAddress"
          :initialValue="registrationData.email"
        />
        <div
          class="buttonArea send"
          @click="onClickSubmit()"
          :class="{ disabled: !checkAll }"
        >
          <div class="buttonMainArea">応募する</div>
        </div>
      </div>
    </div>
    <div class="modal" v-else-if="modalState === 'sended'">
      <TitleArea
        text="景品応募"
        @click-close="onClickCloseSubmitPage"
        :showReturn="true"
      />
      <div class="modal-content-area modal-center">
        <p class="explain">応募が完了しました</p>

        <div class="buttonArea green" @click="onClickReturnMypage">
          <div class="buttonMainArea">マイページに戻る</div>
        </div>
        <div class="buttonArea green" @click="onClickReturnExplain">
          <div class="buttonMainArea">続けて応募する</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import TitleArea from "@/components/Atoms/TitleArea";
import InputMailAddress from "@/components/Input/InputMailAddress";
import ButtonTextLink from "@/components/Atoms/ButtonTextLink";
import PresentMyData from "@/components/MyPage/PresentMyData";
import Caution from "@/components/MyPage/Caution";
import PointShortage from "@/components/MyPage/PointShortage";
import Firebase from "./../../firebase";

const KEIHIN_LIST = [
  {
    id: "A",
    name: "A賞 JCBギフトカード 5万円分",
    sub: "抽選で合計3名様",
    img: require("@/assets/present/jcb.png"),
  },
  {
    id: "B",
    name: "B賞 富士急ハイランド ペアチケット",
    sub: "抽選で合計15組",
    img: require("@/assets/present/fujiq_a.png"),
  },
  {
    id: "C",
    name: "C賞 クオ・カードペイ 1,000円分",
    sub: "抽選で合計100名様",
    img: require("@/assets/present/quopay_b.png"),
  },
];

export default {
  name: "present-modal",
  components: {
    TitleArea,
    InputMailAddress,
    ButtonTextLink,
    PresentMyData,
    Caution,
    PointShortage,
  },
  data() {
    return {
      // 'explain' -> 'send'
      modalState: "explain",
      mailadress: undefined,
      checkMaillAddress: false,
      selectedCourse: undefined,
    };
  },
  computed: {
    ...mapState(["registrationData", "isLoggedInWithFirebaseAuth"]),
    checkAll() {
      return this.checkMaillAddress;
    },
    keihinList() {
      return KEIHIN_LIST;
    },
    canUsePoint() {
      return this.registrationData.Point;
    },
  },
  methods: {
    ...mapMutations(["loadingStartMini", "loadingEndMini"]),
    onClickOpen() {
      this.modalState = "explain";
    },
    onClickClose() {
      this.$emit("click-button");
    },
    onClickGoSubmitPage(payload) {
      if (this.canUsePoint < 100) return;
      this.modalState = "send";
      this.selectedCourse = payload;
    },
    onClickCloseSubmitPage() {
      this.modalState = "explain";
    },
    changeMailAddress(value) {
      this.mailadress = value.value;
      this.checkMaillAddress = value.check;
    },
    onClickReturnMypage() {
      this.$emit("click-button");
    },
    onClickReturnExplain() {
      this.modalState = "explain";
    },
    async onClickSubmit() {
      if (!this.checkAll || this.canUsePoint < 100) return;
      this.loadingStartMini();
      await Firebase.sendOubo({
        name: this.selectedCourse.name,
        mailAddress: this.mailadress,
      });
      this.modalState = "sended";
      this.loadingEndMini();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";

.explain {
  text-align: center;
  font-size: 0.8rem;
  margin: 0.5rem 0;
}
.buttonArea {
  margin: 0.5rem 1.25rem;
  border-radius: 4px;
  background: #ff7c86;

  &.send {
    margin: 0.5rem 0;
  }

  &.green {
    background: #5cd5d6;
  }
  &.disabled {
    background: #c3c3c3;
  }
  .buttonMainArea {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.75rem 0;
    color: white;
    font-size: 1.1rem;
    font-weight: 700;
    img {
      height: 1rem;
      margin: auto 0;
      margin-right: 0.25rem;
    }
  }
}
.modal {
  background-color: white;
  z-index: 1;
  position: fixed;
  width: 100%;
  height: 100%;
  .modal-content-area {
    padding: 2.8rem 1.25rem;
    height: calc(100% - 6rem);
    overflow: scroll;
    &.modal-center {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
}

.card {
  border: #c3c3c3 solid 1px;
  border-radius: 16px;
  background: #fff;
  box-shadow: 2px 2px 2px 0px rgba(1, 39, 76, 0.2);
  padding: 0.5rem 0.25rem;
  margin: 1rem 0;
  .card-flex-area {
    display: flex;
    padding: 0.5rem;
    img {
      width: 25vw;
      margin-right: 0.5rem;
    }
    .right {
      text-align: right;
      font-size: 0.7rem;
      margin-top: 0.2rem;
    }
    p {
      margin: 0;
    }
  }
}
.oubo-img-wrapper {
  display: flex;
  justify-content: center;
  .oubo-img {
    width: 50vw;
    margin: 0 0 0.25rem;
  }
}
.oubo-explain {
  font-size: 1.1rem;
  text-align: center;
  font-weight: 700;
  margin: 0 0 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/MyPage/PresentModal.vue